/** Размер иконки на кнопке, в заголовке и строке списка. */
export const ICON_SIZE = 16
/** Размер иконки в плашке (состояние, предупреждение, пометка «в архиве»). */
export const ICON_SIZE_SMALL = 14
